import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'textFormat',
  standalone: true
})
export class TextFormatPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string): SafeHtml {
    if (!text) {
      return '';
    }

    // Split text into lines to process block-level elements
    let lines = text.split('\n');
    let inList = false;
    let listType = '';
    let formattedLines = [];

    // Process each line
    for (let i = 0; i < lines.length; i++) {
      let line = lines[i];

      // Process headers (lines starting with #)
      if (line.match(/^#\s+/)) {
        if (inList) {
          // Close the list if we were in one
          formattedLines.push(listType === 'ul' ? '</ul>' : '</ol>');
          inList = false;
        }
        line = line.replace(/^#\s+(.*?)$/, '<h1>$1</h1>');
      } else if (line.match(/^##\s+/)) {
        if (inList) {
          formattedLines.push(listType === 'ul' ? '</ul>' : '</ol>');
          inList = false;
        }
        line = line.replace(/^##\s+(.*?)$/, '<h2>$1</h2>');
      } else if (line.match(/^###\s+/)) {
        if (inList) {
          formattedLines.push(listType === 'ul' ? '</ul>' : '</ol>');
          inList = false;
        }
        line = line.replace(/^###\s+(.*?)$/, '<h3>$1</h3>');
      }
      // Process bullet points (lines starting with * or -)
      else if (line.match(/^[*-]\s+/)) {
        if (!inList || listType !== 'ul') {
          if (inList) {
            // Close the previous list if it was a different type
            formattedLines.push(listType === 'ul' ? '</ul>' : '</ol>');
          }
          // Start a new unordered list
          formattedLines.push('<ul>');
          inList = true;
          listType = 'ul';
        }
        line = line.replace(/^[*-]\s+(.*?)$/, '<li>$1</li>');
      }
      // Process numbered lists (lines starting with numbers followed by a period)
      else if (line.match(/^\d+\.\s+/)) {
        if (!inList || listType !== 'ol') {
          if (inList) {
            // Close the previous list if it was a different type
            formattedLines.push(listType === 'ul' ? '</ul>' : '</ol>');
          }
          // Start a new ordered list
          formattedLines.push('<ol>');
          inList = true;
          listType = 'ol';
        }
        line = line.replace(/^\d+\.\s+(.*?)$/, '<li>$1</li>');
      }
      // Regular paragraph
      else {
        if (inList) {
          // Close the list if we were in one and this is not a list item
          formattedLines.push(listType === 'ul' ? '</ul>' : '</ol>');
          inList = false;
        }

        // Only add a break if the line is empty, not the last line, and not followed by another empty line
        if (line.trim() === '' && i < lines.length - 1 && lines[i+1].trim() !== '') {
          line = ''; // '<br>';
        } else if (line.trim() === '') {
          line = ''; // Skip empty lines that don't need a break
        }
      }

      // Process inline formatting for this line
      // Process bold text (double asterisks)
      line = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

      // Process italic text (single asterisks)
      line = line.replace(/\*(.*?)\*/g, '<em>$1</em>');

      formattedLines.push(line);
    }

    // Close any open list
    if (inList) {
      formattedLines.push(listType === 'ul' ? '</ul>' : '</ol>');
    }

    // Join the lines back together
    let formattedText = formattedLines.join('\n');

    // Add CSS for better formatting
    formattedText = `
        ${formattedText}
    `;

    // Return sanitized HTML
    return this.sanitizer.bypassSecurityTrustHtml(formattedText);
  }
}
